import { urlToArray } from '../../../shared/utils';
import {states} from './states'


export const extractLocation = url => {
    const { urlArray, inInd } = urlToArray(url);

    return inInd >= 0 ?
        urlArray.slice(inInd + 1) : [];
}

const testForZip = item => /\d{5}/.test(item);

const matchCityToUrl = locArray => loc =>
    locArray.join('').indexOf(loc.city) === 0;

const matchCityName = (locArray, locationData) => {
    const matches = locationData.filter(matchCityToUrl(locArray));

    if (matches.length > 1) {
        const stateMatch = matches.find(m => locArray.indexOf(m.state) >= 0);
        return stateMatch ? stateMatch.zip : null;
    }

    return matches.length === 0 ? null :
        matches[0].zip;
}


const locationFromUrl = (url, locationData) => {
    const urlArray = extractLocation(url);
    const zip = urlArray.find(testForZip);

    if (urlArray.length === 0) {
        return null;
    }
    return !zip ? matchCityName(urlArray, locationData) : zip;
}

export default locationFromUrl;
